import { Box as MuiBox, BoxProps } from '@mui/material';
import { forwardRef } from 'react';

export const Box = forwardRef(({ ...rest }: BoxProps, ref) => <MuiBox ref={ref} {...rest} />);
